import { Component, NgModule } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { firstValueFrom } from 'rxjs';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { environment } from 'src/app/environments/environments.dev';
import * as moment from 'moment';
import { animate, style, transition, trigger } from '@angular/animations';
import { ModalWorkOrdersComponent } from 'src/app/components/crud/modal-work-orders/modal-work-orders.component';
import { ModalMaintenanceOtComponent } from 'src/app/components/crud/modal-maintenance-ot/modal-maintenance-ot.component';
import { ModalNewBinnacleOtComponent } from 'src/app/components/crud/modal-new-binnacle-ot/modal-new-binnacle-ot.component';
import { ModalSeeWorkOrderComponent } from 'src/app/components/crud/modal-see-work-order/modal-see-work-order.component';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';

@Component({
  selector: 'app-work-orders',
  templateUrl: './work-orders.component.html',
  styleUrls: ['./work-orders.component.css'],
  animations: [
      trigger('buttonAnimation', [
        transition('* => *', [
          animate('0.5s ease-in-out', style({ transform: 'scale(1.1)' })),
          animate('0.5s ease-in-out', style({ transform: 'scale(1)' }))
        ])
      ])
    ],
})

export class WorkOrdersComponent {
  modalRef: MdbModalRef<ModalWorkOrdersComponent> | null = null;
  modalRefMaintenance: MdbModalRef<ModalMaintenanceOtComponent> | null = null;
  modalRefBinnacle: MdbModalRef<ModalNewBinnacleOtComponent> | null = null;
  modalRefSeeWorkOrder: MdbModalRef<ModalSeeWorkOrderComponent> | null = null;
  loadingFull: boolean = false;
  loading: any;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  requestBinnaclesPaginated: any[] = [];
  headers: any = [
    {
      label: '#',
      field: 'id',
      disableSort: false,
    },
    {
      label: 'Validación de componentes',
      field: 'component_stock_verification',
      disableSort: false,
    },
    {
      label: 'Necesita detención de linea',
      field: 'is_necesary_stop_line',
      disableSort: false,
    },
    {
      label: 'Fecha programada',
      field: 'schedule_date',
      disableSort: false,
    },
    { 
      label: 'Comentario para bodega', 
      field: 'comments_to_warehouse', 
      disableSort: false 
    },
    { 
      label: 'Fecha creación', 
      field: 'created_at', 
      disableSort: false 
    },
    { 
      label: 'Estado', 
      field: 'status', 
      disableSort: false 
    },
    { 
      label: 'Tipo', 
      field: 'type',
      disableSort: false 
    },
    { 
      label: 'Acciones', 
      field: '', 
      disableSort: false 
    },
  ];

  esOptions = {
    title: 'SELECCIONE FECHA',
    monthsFull: [
      'enero','febrero','marzo','abril','mayo','junio',
      'julio','agosto','septiembre','octubre','noviembre','diciembre'
    ],
    monthsShort: ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'],
    weekdaysFull: ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
    weekdaysShort: ['dom','lun','mar','mié','jue','vie','sáb'],
    weekdaysNarrow: ['D','L','M','X','J','V','S'],
    okBtnText: 'Aceptar',
    clearBtnText: 'Limpiar',
    cancelBtnText: 'Cancelar'
  };

  createButtonIsVisible: boolean = false;
  createBinnacleButtonIsVisible: boolean = false;
  seeButtonIsVisible: boolean = false;
  validateBinnacleButtonIsVisible: boolean = false;
  addMaintenanceToOTButtonIsVisible: boolean = false;
  start_schedule_date: string = '';
  end_schedule_date: string = '';
  type: string = '';
  requestForm: FormGroup;

  requestWorkOrders: any[] = [];
  requestWorkOrdersPaginated: any[] = [];

  types: any = [
    { id: 1, name: 'Preventivo' },
    { id: 2, name: 'Correctivo' },
    { id: 3, name: 'Bitácora' },
  ];

  constructor(
    private modalService: MdbModalService,
    private crudService: GenericCrudService<any>,
    private fb: FormBuilder
  ) {
    this.requestForm = this.fb.group({
      start_schedule_date: [null],
      end_schedule_date: [null],
      type: [null],
    });
  }

  async ngOnInit(): Promise<void> {
    this.loadingFull = true;
    await Promise.all([
      this.getRequestWorkOrdersByCompanyId(),
    ]);
    this.visibilityButtonsMenu();
    this.loadingFull = false;
  }

  visibilityButtonsMenu() {
    const menu = JSON.parse(localStorage.getItem('Menu') ?? '{}');
    console.log("menu", menu);
    const currentMenuId = localStorage.getItem('IdMenu')?.toString(); // Ensure it is transformed to a string
    console.log("currentMenuId", currentMenuId);
    const currentMenu = menu.detail.find((item: any) => item.Menu.id === currentMenuId);
    const buttons = currentMenu?.Menu.BUTTONS ?? [];
    console.log("buttons", buttons);
    buttons.forEach((button: any) => {
      if (button.BUTTON_ACTION === 'create') {
        this.createButtonIsVisible = true;
      }
      if (button.BUTTON_ACTION === 'create_binnacle') {
        this.createBinnacleButtonIsVisible = true;
      }
      if (button.BUTTON_ACTION === 'read') {
        this.seeButtonIsVisible = true;
      }
      if (button.BUTTON_ACTION === 'validate_by_warehouse') {
        this.validateBinnacleButtonIsVisible = true;
      }
      if (button.BUTTON_ACTION === 'add_maintenance_to_ot') {
        this.addMaintenanceToOTButtonIsVisible = true;
      }
    });
  }

  async getRequestWorkOrdersByCompanyId(): Promise<void> {
    const body = new FormData();
    const id_company = localStorage.getItem('IdCompany') ?? '';
    body.append('action', "SELECT");
    body.append('table_name', 'work_orders');  
    body.append('id_company', id_company);
    const response: any = await firstValueFrom(
      this.crudService.crud(body, environment.GenericCrudOperation)
    );
    if(response && response.status === 1 && response.data) {
      this.requestWorkOrders = response.data.map((item: any) => {
        item.created_at = item.CREATED_AT ? moment(item.CREATED_AT).format('DD-MM-YYYY') : '';
        item.SCHEDULE_DATE = item.SCHEDULE_DATE ? moment(item.SCHEDULE_DATE).format('DD-MM-YYYY') : '';
        return item;
      });
      this.requestWorkOrders = this.requestWorkOrders.sort((a, b) => {
        return b.id - a.id;
      });
    }
    this.onPageChange(1);
  }

  async filterData() {
    const startScheduleDate = this.requestForm.get('start_schedule_date')?.value;
    const endScheduleDate = this.requestForm.get('end_schedule_date')?.value;
    const type = this.requestForm.get('type')?.value;
  
    console.log('Schedule Date:', startScheduleDate);
    console.log('Type:', type);

    await this.getRequestWorkOrdersByCompanyId();
    if(startScheduleDate != null || type != null || endScheduleDate != null) {
      
      if(startScheduleDate != null && startScheduleDate != '') {
        this.requestWorkOrders = this.requestWorkOrders.filter((item: any) => {
          if(moment(item.CREATED_AT).valueOf() >= moment(startScheduleDate).valueOf()) {
            console.log("item", item);
            return item;
          }
        }).sort((a, b) => {
          return b.id - a.id;
        });
      }
      if(endScheduleDate != null && endScheduleDate != '') {
        this.requestWorkOrders = this.requestWorkOrders.filter((item: any) => {
          if(moment(item.CREATED_AT).valueOf() <= moment(endScheduleDate).valueOf()) {
            console.log("item", item);
            return item;
          }
        }).sort((a, b) => {
          return b.id - a.id;
        });
      }

      if(type != null && type != '') {
        this.requestWorkOrders = this.requestWorkOrders.filter((item: any) => {
          if((item.TYPE) === type) {
            return item;
          }
        }).sort((a, b) => {
          return b.id - a.id;
        });
      }
    }
  }
  
  updatePaginatedData() {
    const start = (this.currentPage) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.requestWorkOrdersPaginated = this.requestWorkOrders.slice(start, end);
  }

  onPageChange(event: any) {
    this.currentPage = event.page ?? event - 1;
    this.updatePaginatedData();
  }

  createNewWorkOrder() {
    this.modalRef = this.modalService.open(ModalWorkOrdersComponent);
    this.modalRef.onClose.subscribe(async (event: any) => {
      await this.getRequestWorkOrdersByCompanyId();
      if (!event) {
        return;
      }
    });
  }

  updateByWarehouse(id: any) {
    this.modalRefMaintenance = this.modalService.open(ModalMaintenanceOtComponent, {
      data: {
        id,
      },
      ignoreBackdropClick: true,
    });
    this.modalRefMaintenance.onClose.subscribe(async (event: any) => {
      await this.getRequestWorkOrdersByCompanyId();
      if (!event) {
        return;
      }
    });
  }

  createOrUpdateBinnacle(id: any, type: string) {
    this.modalRefBinnacle = this.modalService.open(ModalNewBinnacleOtComponent, {
      data: {
        id,
        type,
      },
      ignoreBackdropClick: true,
    });
    this.modalRefBinnacle.onClose.subscribe(async (event: any) => {
      await this.getRequestWorkOrdersByCompanyId();
      if (!event) {
        return;
      }
    });
  }

  seeWorkOrder(id: any) {
    this.modalRefSeeWorkOrder = this.modalService.open(ModalSeeWorkOrderComponent, {
      data: {
      id,
      },
      ignoreBackdropClick: true,
      modalClass: 'modal-xl',
    });
    this.modalRefSeeWorkOrder.onClose.subscribe(async (event: any) => {
      await this.getRequestWorkOrdersByCompanyId();
      if (!event) {
        return;
      }
    });
  }
}
